"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserRecorderTracker = void 0;
var _debug = _interopRequireDefault(require("debug"));
var _base = require("./base");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); } /* eslint-disable class-methods-use-this */
var debug = (0, _debug.default)('rentspree-tracker:user-recorder');

/**
 * This class for capturing user behavior and user reaction on the website
 */
var UserRecorderTracker = exports.UserRecorderTracker = /*#__PURE__*/function (_BaseTracker) {
  _inherits(UserRecorderTracker, _BaseTracker);
  function UserRecorderTracker() {
    _classCallCheck(this, UserRecorderTracker);
    return _callSuper(this, UserRecorderTracker, arguments);
  }
  _createClass(UserRecorderTracker, [{
    key: "identifyUser",
    value:
    /**
     * identity the user information to provider script for mapping user on user recording provider
     * @param {Object} profile the user data object
     */
    function identifyUser(profile) {
      debug('=== UserRecorderTracker identifyUser is running... 💫 ===');
      debug('user data %o => ', profile);
      UserRecorderTracker.getTracker().identify(profile);
      debug('=== UserRecorderTracker identifyUser finished ✅ ===');
    }

    /**
     * This method is removing session recording with Local Storage and Cookie
     * for getting a newer recording session for recording correct a new user logged in
     */
  }, {
    key: "logout",
    value: function logout() {
      debug('=== UserRecorderTracker logout is running... 💫  ===');
      UserRecorderTracker.getTracker().clearSession();
      debug('=== UserRecorderTracker logout finished ✅ ===');
    }
  }], [{
    key: "getTracker",
    value:
    /**
     * Static method for getting the tracker from window
     * @returns {Object | Proxy} the user-recorder object from the provider
     * if the function is not existed, this method will return Proxy to avoid error
     * @static
     */
    function getTracker() {
      if (window.userRecorder) {
        return window.userRecorder;
      }
      debug('Warning! Seems like window.userRecorder is undefined');
      return new Proxy({}, {
        get: function get() {
          return function () {};
        }
      });
    }
  }]);
  return UserRecorderTracker;
}(_base.BaseTracker);